import { Component, Output, Input, EventEmitter, OnInit } from '@angular/core';
import { Router } from '@angular/router'
import { ClienteService } from './services/cliente.service';
import { Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { interval } from 'rxjs';
import { ActivatedRoute } from "@angular/router";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'bantrabweb';
  constructor(
    @Inject(DOCUMENT) private document: Document,
    public router: Router,
    private clienteservice: ClienteService) {
  }

  ngOnInit() {
  }

  ngAfterContentChecked() {
     const path = window.location.pathname;
    if(path.includes("gestiones")) {
      this.document.body.classList.add('gestiones');
    } else {
      this.document.body.classList.remove('gestiones');
    }
  }
}
